import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lens-details',
  templateUrl: './lens-details.component.html',
  styleUrls: ['./lens-details.component.css']
})
export class LensDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
